<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<div>
								<p class="mb-0 font-weight-bold text-primary title">Editar Datos Proyecto</p>
							</div>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <v-form ref="form" v-model="validform" class="mt-6">
							<v-row>
								<v-col class="py-2">
									<v-text-field
										label="Nombre Proyecto"
										v-model="project.name"
										outlined
										hide-details
										required
										dense
										color="secondary"
										item-color="secondary"
										:rules="requiredRule"
									></v-text-field>
								</v-col>
							</v-row>

							<v-row>
								<v-col class="py-2">
									<v-autocomplete
										v-model="project.address"
										:items="[...items, ...[project.address]]"
										name="address"
										:search-input.sync="search"
										prepend-inner-icon="mdi-map-marker"
										label="Dirección"
										placeholder="Dirección"
										autocomplete="off"
										outlined
										dense
										hide-details
										:loading="loading"
										:filter="d => d"
										color="secondary"
										item-color="secondary"
										return-object
										:rules="requiredRule"
										@change="change"
									></v-autocomplete>
								</v-col>
							</v-row>

							<v-row>
								<v-col class="py-2">
									<v-select
										v-model="project.state_id"
										:items="$store.state.general.states"
										:loading="$store.state.general.loadingStates"
										:menu-props="{ top: true, offsetY: true }"
										item-text="name"
										item-value="id"
										label="Seleccione Región"
										outlined
										dense
										hide-details
										color="secondary"
										:rules="requiredRule"
										@change="onChangeState"
									></v-select>
								</v-col>
								<v-col class="py-2">
									<v-select
										v-model="project.district_id"
										:items="$store.state.general.cities"
										:loading="$store.state.general.loadingCities"
										item-text="name"
										item-value="id"
										label="Seleccione Municipio"
										outlined
										dense
										color="secondary"
										:rules="requiredRule"
										hide-details
									></v-select>
								</v-col>
							</v-row>

							<v-row>
								<v-col class="py-2">
									<v-select
										v-model="project.zone_id"
										:items="$store.state.projects.zoneIpt"
										:loading="$store.state.projects.loadingZoneIpt"
										:menu-props="{ top: true, offsetY: true }"
										item-text="name"
										item-value="id"
										label="Selecciona Zona Proyecto"
										outlined
										hide-details
										dense
										required
										color="secondary"
										:rules="requiredRule"
									></v-select>
								</v-col>
								<v-col class="py-2">
									<ProjectTypeSelectorMenuSelect
											:fullView="true"
											:denseInput="false"
											:projectType="projectType"
											:onClick="(project_type) => { projectType = project_type }"/>
									<!-- <v-combobox
										v-model="projectTypeProxy"
										:items="projectTypeOptions"
										:filter="customFilter"
										:loading="$store.state.companies.loadingCompaniesProjectTypes"
										item-text="name"
										item-value="value"
										dense
										outlined
										label="Selecciona tipo de proyecto"
										clearable
										:rules="requiredRule"
									>
										<template v-slot:item="{ item }">
											<div v-if="item.header" class="font-weight-bold caption">
												{{ item.header }}
											</div>
											<div v-else-if="item.isSubType" class="caption ml-2">
												{{ item.name }}
											</div>
											<div v-else class="caption font-weight-bold">
												{{ item.name }}
											</div>
										</template>
									</v-combobox> -->
								</v-col>
							</v-row>

              <v-row align="center">
                <v-col cols="12">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mx-2 my-1"
                      color="white"
                      raised
                      @click="closeModal"
                    >
                      <p class="mb-0 text-primary">Cancelar</p>
                    </v-btn>
                    <v-btn
                      class="mx-2 my-1"
                      color="#524D4D"
                      raised
                      dark
                      :loading="loading"
                      @click="confirmProject"
                    >
                      <p class="mb-0">Confirmar</p>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import { gmapApi } from 'vue2-google-maps'
import {updateProjectInfo} from '@/helpers/api/projects'
import ProjectTypeSelectorMenuSelect from '@/components/Helpers/Components/ProjectTypeSelectorMenuSelect'

export default {
  name: 'EditProjectModal',
	components: {ProjectTypeSelectorMenuSelect},
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		search: '',
		items: [],
		autocompleteService: null,
		projectName: null,
		budget: null,
		project: {
			name: null,
			client_id: null,
			address: null,
			address_id: null,
			state_id: null,
			district_id: null,
			zone_id: null,
			project_type_id: null,
			licence: false,
			reception: false,
			area: null,
			general_regulations: null,
			specific_regulations: null,
			regulatory_plan: null,
			coordinates: null
		},
		loading: false,
		projectType: null,
		isGeneralStage: true,
		zoneId: null,
		newStageName: null,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		projectTypeProxy: {
			get() {
				return this.projectType
					? this.projectTypeOptions.find(opt => opt.value === this.projectType)
					: null;
			},
			set(val) {
				this.projectType = val ? val.value : null;
			},
		},
		projectTypeOptions() {
			const options = [];
			if(!this.$store.state.companies.companiesProjectTypesCategories) return options
			this.$store.state.companies.companiesProjectTypesCategories.forEach(category => {
				options.push({ header: category.name });
				category.project_types.forEach(pt => {
					options.push({ name: pt.name, value: pt.id, isParent: true, sub_types: pt.sub_types });
					pt.sub_types.forEach(st => {
						options.push({ name: st.name, value: st.id, isSubType: true });
					});
				});
			});
			return options;
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		google: gmapApi,
		clientInfo(){
			const found = this.$store.state.users.companyClients.find(user => user.id == this.project.client_id)
			console.log(found)
			return found
		}
  },
	watch: {
    search(newSearch) {
      if (newSearch) {
        this.googleSearch(newSearch);
      } else {
        this.items = []; // Limpiar los resultados si no hay búsqueda
      }
    },
	},
  mounted(){
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
		this.$nextTick(() => {
			this.$gmapApiPromiseLazy().then(() => {
				this.autocompleteService = new this.google.maps.places.AutocompleteService()
			})
			this.$store.dispatch('users/getCompanyClients')
		});
		this.$store.dispatch('projects/getAllZoneIpts')
		this.setProjectInfo()
  },
  methods: {
		customFilter(item, queryText, itemText) {
			if (item.header) return true;
			const text = (itemText || '').toLowerCase();
			const query = queryText.toLowerCase();
			if (text.includes(query)) return true;
			if (item.isParent && item.sub_types?.some(st => st.name.toLowerCase().includes(query))) {
				return true;
			}
			return false;
		},
		async setProjectInfo(){
			this.project.client_id = this.$store.state.projects.editProjectModal.client_id
			this.project.doc_type = this.$store.state.projects.editProjectModal.doc_type
			this.project.zone_id = this.$store.state.projects.editProjectModal.info.zone_id

			this.project.address = null
			this.project.address_id = null
			this.project.state_id = null
			this.project.district_id = null
			this.project.preproject_id = null

			this.project.project_type = this.$store.state.projects.editProjectModal.info.project_type
			this.projectType = this.project.project_type

			const info = this.$store.state.projects.editProjectModal
			this.project.name = info.name
			this.project.preproject_id = info.preproject_id
			if(info && info.info){
				this.project.project_type_id = info.info.project_type_id
				if(info.info.address){
					this.project.address = info.info.address.address
					this.project.address_id = info.info.address_id
					if(info.info.address.state_id){
						this.project.state_id = info.info.address.state_id
						this.onChangeState(this.project.state_id)
						this.project.district_id = info.info.address.district_id
					}
				}
			}
		},
		changeProject(project){
			this.project.address = null
			this.project.address_id = null
			this.project.state_id = null
			this.project.district_id = null
			this.project.preproject_id = null
			const info = this.clientProjects.find(client_project => client_project.id == project)
			this.project.name = info.name
			if(info && info.info){
				this.project.project_type_id = info.info.project_type_id
				if(info.info.address){
					this.project.address = info.info.address.address
					this.project.address_id = info.info.address_id
					if(info.info.address.state_id){
						this.project.state_id = info.info.address.state_id
						this.onChangeState(this.project.state_id)
						this.project.district_id = info.info.address.district_id
					}
				}
			}
		},
		isNumberKey(event) {
			const charCode = event.which ? event.which : event.keyCode;
			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}
		},
    googleSearch(query) {
      const options = {
        input: query,
				componentRestrictions: { country: 'CL' }
      };
      this.autocompleteService.getPlacePredictions(options, (predictions, status) => {
        if (status === this.google.maps.places.PlacesServiceStatus.OK) {
          this.items = predictions.map(prediction => ({
            text: prediction.description,
            value: prediction 
          }));
        } else {
          console.error('Error fetching predictions: ', status);
          this.items = [];
        }
      });
    },
		async getPlaceDetails(placeId) {
			if (typeof this.google !== 'undefined' && this.google.maps) {
				const service = new this.google.maps.places.PlacesService(document.createElement('div'));
				
				service.getDetails({ placeId }, (place, status) => {
					if (status === this.google.maps.places.PlacesServiceStatus.OK) {
						const { geometry } = place;
						this.project.coordinates = {
							lat: geometry.location.lat(),
							lng: geometry.location.lng()
						}
					}
				});
			} else {
				console.error('Google Maps API no está cargada');
			}
		},
    change(value) {
			this.placeChanged = true
			this.getPlaceDetails(value.value.place_id)
      this.project.address = value.text;
			this.project.address_id = null
    },
		onChangeState(state){
			this.$store.dispatch('general/getCities', state)
		},
    closeModal(){
			this.$store.commit('projects/setEditProjectModal', null)
			this.projectType = null
			this.zoneId = null
      this.validform = true
      this.loading = false
			this.project = {
				name: null,
				address: null,
				client_id: null,
				state_id: null,
				district_id: null,
				zone_id: null,
				project_type_id: null,
				licence: false,
				reception: false,
				area: null,
				general_regulations: null,
				specific_regulations: null,
				regulatory_plan: null
			}
    },
		async confirmProject(){
      if(this.$refs.form.validate()){
				this.loading = true
				let data = {
					...{project_id: this.$store.state.projects.editProjectModal.id},
					...this.project
				}
				console.log('project', data)
				// if(data){
				// 	this.loading = false
				// 	return null
				// }
				const contract = await updateProjectInfo(data)
				if(contract.code == 200){
					this.reloadParent()
					this.$store.dispatch('projects/getProjects')
					this.closeModal()
          const messageData = {
            message: 'Se ha actualizado correctamente el proyecto',
            title: 'Proyecto Creado',
            type: 'success',
            icon: 'mdi-check-circle',
            color: '#3EBFA3',
          }
          this.setMessage(messageData)
        }
        else{
          const messageData = {
            message: 'Hubo un error en la operación, por favor intenta nuevamente',
            title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
          }
          this.setMessage(messageData)
        }
				this.loading = false
			}
		},
		reloadParent(){
			if(this.$store.state.projects.editProjectModal.parent_type == 'contract'){
				eventBus.$emit('reloadInformation', { contract_id: this.$store.state.projects.editProjectModal.parent_id })
			}
			if(this.$store.state.projects.editProjectModal.parent_type == 'budget'){
				eventBus.$emit('reloadInformation', { budget_id: this.$store.state.projects.editProjectModal.parent_id })
			}
			if(this.$store.state.projects.editProjectModal.parent_type == 'report'){
				eventBus.$emit('reloadInformation', { report_id: this.$store.state.projects.editProjectModal.parent_id })
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
		position: relative;
		width: 200px;
	}
	.profile-image{
		width: 100%;
		height: 150px;
	}
	.logo-text{
		position: absolute;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		width: 100%;
		color: white;
		font-size: 12px;
		padding: 5px 10px;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>